module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-intro.7e844609.mp3";